<template>
    <checkbox-input
        v-model="selected"
        :value="column.value"
        class="text-sm mt-sm"
    >
        {{ column.label }}
    </checkbox-input>
</template>

<script>
    export default {
        props: {
            column: {
                type: Object,
                required: true,
            },
            storeName: {
                type: String,
                required: true,
            },
            selectedColumns: {
                type: Array,
                required: true,
            },
        },
        computed: {
            selected: {
                get() {
                    return this.selectedColumns.findIndex((column) => column.value === this.column.value) > -1;
                },
                set() {
                    this.$store.dispatch(`${this.storeName}/toggleColumn`, this.column);
                },
            },
        },
    };
</script>
